// import variables from '../variables';
/* eslint-disable */
const MuiSelect = {
  select: {
    // borderColor: variables.colors.coral,
  },
};

export default MuiSelect;
